/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBadgeOff = createReactComponent("outline", "badge-off", "IconBadgeOff", [["path", { "d": "M7 7v10l5 3l5 -3m0 -4v-9l-5 3l-2.496 -1.497", "key": "svg-0" }], ["path", { "d": "M3 3l18 18", "key": "svg-1" }]]);

export { IconBadgeOff as default };
//# sourceMappingURL=IconBadgeOff.mjs.map
